import React from 'react';
import { ProviderMatchProviderLocationV9 } from '@kyruus/types';

const LocationAccessibility = ({
  location
}: {
  location: ProviderMatchProviderLocationV9;
}): React.ReactElement | null => {
  const { accessibility = [] } = location;

  if (!accessibility || !accessibility.length) return null;

  return (
    <>
      {accessibility.map((item: { _entity_id: string; name: string }) => (
        <li key={item.name} data-testid={item['_entity_id']}>
          {item.name}
        </li>
      ))}
    </>
  );
};

export default LocationAccessibility;
